import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import idioma_lbl from "./index";

export default function Edad({ handler_data, handler_obj }) {
  return (
    <React.Fragment>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Typography align="center" variant="h6" gutterBottom>
            {idioma_lbl === "en" ? "Your age?" : "¿Tu edad?"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <TextField
            inputProps={{ min: 0, style: { textAlign: "center" } }}
            required
            id="age"
            name="edad"
            variant="standard"
            onChange={handler_data}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
